import React, { useContext } from "react";
import pptpage from "../Charginganalysis_Bus/CESL_Charging_Analytics_Navigation_Guide.pdf"
import DashboardMain_Bus from "../DashboardMain_Bus/DashboardMain_Bus";
// import DashboardMain from '../DashboardMain/DashboardMain';
import AppContext from '../../../store/AppContext';

function PPTPage_Charging_Bus() {
  const app_ctx = useContext(AppContext);

  return (
    <>
      <DashboardMain_Bus>
        <iframe src={pptpage} frameborder="0" height="539em" width="100%" sandbox></iframe>
      </DashboardMain_Bus>
    </>
  );
}

export default PPTPage_Charging_Bus;